import { createAction } from '@reduxjs/toolkit';

export const FORWARD_VOICEMAIL_ACTION_TYPE = 'saga/forwardVoicemail';
export const forwardVoicemailAction = createAction(FORWARD_VOICEMAIL_ACTION_TYPE);
